<template>
    
<section class="finance">

    <div class="panel">

        <div class="panel-heading"><h2>Invoices</h2></div>
        <div class="panel-body">
            <div class="form-group text-center">
                <button @click.prevent="authorizeVersapay()" class="btn btn-success" style="margin-top:2rem;">Pay My Tuition</button>
            </div>
        </div>
    </div>
</section>

</template>


<script>

    import oauth from '../services/oauth';

    export default {
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            authorizeVersapay() {
            var redirect_uri = this.$route.query.redirect_uri;
            
            var data = {
                client_id: this.$route.query.client_id,
                redirect_uri: redirect_uri,
                user: localStorage.account_id
            }
            oauth.getCode(this, data).then(function(response) {                
                window.location = redirect_uri + '?code=' + response.data.authorizationCode;
            });
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Finance.vue?3e72f2b4